import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommentaireService {

  baseURL = "http://localhost:9091/commentaire"

  constructor(private commentairehttp: HttpClient) { }

  getAllCommentaires(): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/getAll");
  }

  addCommentaire(idBlog: any, idUser: any, commentaire: any): Observable<any> {
    return this.commentairehttp.post(this.baseURL + "/addCommentaire/" + idBlog + "/" + idUser, commentaire);
  }
  addCommentairePost(idPost: any, idUser: any, commentaire: any): Observable<any> {
    return this.commentairehttp.post(this.baseURL + "/addCommentairePost/" + idPost + "/" + idUser, commentaire);
  }
  addCommentaireEvent(idEvent: any, idUser: any, commentaire: any): Observable<any> {
    return this.commentairehttp.post(this.baseURL + "/addCommentaireEvent/" + idEvent + "/" + idUser, commentaire);
  }
  addCommentaireUser(idtargetUser: any, idUser: any, commentaire: any): Observable<any> {
    return this.commentairehttp.post(this.baseURL + "/addCommentaireUser/" + idUser + "/" + idtargetUser, commentaire);
  }
  repondreACommentaire(id: any, commentaire: any): Observable<any> {
    return this.commentairehttp.post(this.baseURL + "/Reponse/" + id, commentaire);
  }


  deleteCommentaire(id: any): Observable<any> {
    return this.commentairehttp.delete(this.baseURL + "/deleteCommentaire/" + id);
  }

  updateCommentaire(id: any, commentaire): Observable<any> {
    return this.commentairehttp.put<any>(this.baseURL + "/Update/" + id, commentaire)
  }

  getCommentaireById(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/getById/" + id);
  }
  

  getCommentaireByBlogId(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/getByBlogId/" + id);
  }
  getCommentaireByPostId(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/getByPostId/" + id);
  }
  getCommentaireByEventId(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/getByEventId/" + id);
  }
  getCommentaireByUserId(userId: any ,targetUserId :any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/getByUserId/" + userId+"/"+targetUserId);
  }

  getCommentaireBytargetUserId(targetUserId:any ):Observable<any>{
    return this.commentairehttp.get(this.baseURL+ "/getBytargetUserId/"+targetUserId);
  }

  countCommentaireByBlogId(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/CountCommentaireByBlogId/" + id);
  }
  countCommentaireByPostId(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/CountCommentaireByPostId/" + id);
  }

  countCommentaireByEventId(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/CountCommentaireByEventId/" + id);
  }

  countCommentaire(): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/CountCommentaire");
  }

  getReponseByCommentaireId(id: any): Observable<any> {
    return this.commentairehttp.get(this.baseURL + "/getReponseByIdCommentaire/" + id);
  }
}
